module.exports = __webpack_public_path__ + "fonts/3MCircularTT-Book.9b28e83c.ttf";